import axios from 'axios';

// Automatically configure the base URL for Axios based on environment variables.
// This allows the app to work with a backend on a different domain (like Render)
// without relying on the 'proxy' field in package.json (which Vercel ignores).

if (process.env.REACT_APP_API_URL) {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
}

export default axios;
